module.exports = __webpack_public_path__ + "img/1624.bc538c3a.png";